import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '@/components/layout/Header';
import Sidebar from '@/components/layout/Sidebar';
import Content from '@/components/layout/Content';
import { EmbeddingSyncProvider } from '@/contexts/EmbeddingSyncContext';

const MainLayout: React.FC = () => {
  // 控制侧边栏展开/折叠状态
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(() => typeof window !== 'undefined' && window.matchMedia('(max-width: 767px)').matches);

  React.useEffect(() => {
    const viewport = window.matchMedia('(max-width: 767px)');
    const collapseOnNarrowViewport = () => { if (viewport.matches) setSidebarCollapsed(true); };
    viewport.addEventListener('change', collapseOnNarrowViewport);
    return () => viewport.removeEventListener('change', collapseOnNarrowViewport);
  }, []);

  const toggleSidebar = () => {
    setSidebarCollapsed((collapsed) => !collapsed);
  };

  return (
    <EmbeddingSyncProvider>
      <div className="flex flex-col h-screen bg-gray-100 dark:bg-gray-900">
        {/* 顶部导航 */}
        <Header onToggleSidebar={toggleSidebar} />

        <div className="relative flex min-h-0 flex-1 overflow-hidden">
          {/* 侧边导航 */}
          <Sidebar collapsed={sidebarCollapsed} />

          {/* 主内容区域 */}
          <Content>
            <Outlet />
          </Content>
        </div>

        {/* Footer */}
        <footer className="shrink-0 border-t border-gray-200 bg-white/50 dark:border-gray-700 dark:bg-gray-900/50">
          <div className="flex flex-col items-center justify-center gap-1 px-4 py-2 text-xs text-gray-500 dark:text-gray-400 sm:flex-row sm:gap-3">
            <span>&copy; 2026 Pcnaid Inc. All rights reserved.</span>
            <span className="hidden sm:inline">&middot;</span>
            <a href="https://policies.pcnaid.com/privacy" target="_blank" rel="noopener noreferrer" className="hover:text-gray-700 dark:hover:text-gray-200 underline">Privacy Policy</a>
            <span className="hidden sm:inline">&middot;</span>
            <a href="https://policies.pcnaid.com/terms" target="_blank" rel="noopener noreferrer" className="hover:text-gray-700 dark:hover:text-gray-200 underline">Terms of Service</a>
          </div>
        </footer>
      </div>
    </EmbeddingSyncProvider>
  );
};

export default MainLayout;
